import { Phase } from "../hooks/useTrainingEngine";

export function StatusLabel({ phase, remainingMs }: { phase: Phase; remainingMs: number }) {
    const isFinal10 = (phase === "work" || phase === "rest") && remainingMs <= 10_000 && remainingMs > 0;
    const label =
        phase === "ready" ? "READY" : phase === "work" ? "WORK" : phase === "rest" ? "REST" : "COMPLETE";

    const color = isFinal10 ? "text-amber-300" : phase === "work" ? "text-[var(--gold)]" : phase === "rest" ? "text-[var(--rest)]" : "text-[var(--muted)]";

    return (
        <div className={`text-xs font-semibold tracking-[0.18em] ${color} transition-colors duration-[var(--dur-base)] ease-[var(--ease-inout)]`}>
            {label}
        </div>
    );
}
